/* eslint-disable @typescript-eslint/no-explicit-any */
type F = (...args: any[]) => void;

export function throttle(func: F, limitMs: number) {
  let inThrottle = false;
  return function(this: any, ...args: any[]) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limitMs);
    }
  };
}
